/** A link as the editor stores it: a scheme when none was typed, no
 *  trailing slash. Shared by the formatting bar's link dialog and the
 *  selection toolbar's link field. */
export const normalizeLinkUrl = (raw: string): string => {
  let url = raw.trim();
  if (!/^https?:\/\//i.test(url)) url = `http://${url}`;
  return url.replace(/\/$/, "");
};
